var map = {
	"./avacado.png": 89,
	"./broccoli.png": 83,
	"./chees.png": 93,
	"./cottage-cheesee.png": 92,
	"./eggs.png": 90,
	"./mushroom.png": 84,
	"./noots.png": 95,
	"./olives.png": 94,
	"./peas.png": 85,
	"./pepper.png": 86,
	"./pistachios.png": 96,
	"./potato.png": 87,
	"./tomato.png": 88,
	"./yogurt.png": 91
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 365;